import { validate } from "email-validator"

export const isEmailValid = validate
